import { StorageAdapter } from '../storage-adapter';

export class SessionStorageAdapter implements StorageAdapter {
  getAll<T>(): T {
    const object: Record<string, any> = {};
    const keys = Object.keys(sessionStorage);

    keys.forEach(name => {
      object[name] = sessionStorage.getItem(name);
    });

    return object as T;
  }

  setAll(object: Record<string, any>): void {
    const keys = Object.keys(object);

    keys.forEach(name => {
      if (object[name]) {
        sessionStorage.setItem(name, object[name]);
      }
    });
  }

  deleteAll(): void {
    const keys = Object.keys(sessionStorage);
    keys.forEach(name => {
      sessionStorage.removeItem(name);
    });
  }

  setItem(name: string, values: string): void {
    sessionStorage.setItem(name, values);
  }

  removeItem(name: string): void {
    sessionStorage.removeItem(name);
  }

  getItem(name: string) {
    return sessionStorage.getItem(name) || '';
  }
}
